import { render, staticRenderFns } from "./ServiceField.vue?vue&type=template&id=308aede7&"
import script from "./ServiceField.vue?vue&type=script&lang=js&"
export * from "./ServiceField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports